import {Component, Input, OnInit} from "@angular/core";
import {EmpresaService} from "../../services/empresa.service";
import {ActivatedRoute} from "@angular/router";
import {ConstantsService} from "../../fidelidade/ConstantsService";


@Component({
  selector: 'app-tela-integracao-99food',
  templateUrl: './tela-integracao-99food.component.html',
  styleUrls: ['./tela-integracao-99food.component.scss']
})
export class TelaIntegracao99FoodComponent implements OnInit {
  @Input() empresa: any = {};
  novaIntegracao: any;
  mensagemErro: string;
  authId: string;
  carregando = false;
  sincronizando = false;
  constructor(private empresaService: EmpresaService,
              private  activatedRoute: ActivatedRoute, private constantsService: ConstantsService) {
  }

  ngOnInit(): void {
    this.authId = this.activatedRoute.snapshot.queryParams.authId;

    if (this.authId) {
      this.carregando = true;
      this.constantsService.empresa$.subscribe((empresa) => {
        if (empresa) {
          this.empresa = empresa;
          if (!this.possuiIntegracao()) {
            this.buscarLojasAutorizadas();
          } else {
            this.carregando = false;
          }
        }
      });
    } else if (!this.possuiIntegracao()) {
      this.novaIntegracao99Food();
    }
  }

  private buscarLojasAutorizadas(): void {
    this.empresaService.obtenhaLojasAtivar99Food(this.authId).then((lojas: any) => {
      this.carregando = false;
      if (lojas && lojas.length) {
        this.novaIntegracao99Food(lojas);
      } else {
        this.mensagemErro = 'Nenhuma loja retornada para ativação.';
      }
    }).catch((erro) => {
      this.carregando = false;
      this.mensagemErro = erro?.message || erro;
    });
  }

  novaIntegracao99Food(lojasAtivar: any[] = null): void {
    this.novaIntegracao  = { nova: true };
    if (lojasAtivar) {
      this.novaIntegracao.lojasAtivar = lojasAtivar;
    }
    if (this.authId) {
      this.novaIntegracao.authId = this.authId;
    }
  }

  possuiIntegracao(): boolean {
    const integracoes = this.obtenhaIntegracoesFood99();
    return Array.isArray(integracoes) && integracoes.length > 0;
  }

  obtenhaIntegracoesFood99(): any[] {
    return this.empresa?.integracoes99Food || this.empresa?.integracoes99Food || [];
  }

  sincronizarFormasPagamentos(){
    this.sincronizando = true;

    this.empresaService.sincronizeFormasPagamento99Food().then((res: any) => {
      this.sincronizando = false;
    }).catch( (erro) => {
      this.mensagemErro = erro;
      this.sincronizando = false
      alert(erro)
    })
    return false;
  }
}
